// extracted by css-extract-rspack-plugin
export default {"container":"_2967e0b","radioInputs":"_562c7998"};